import { atom } from 'recoil';

export const purchaseModalAtom = atom<{ visible: boolean, id: number | undefined }>({
	key: 'purchaseModal',
	default: {
		visible: false,
		id: undefined
	}
});
